import React from 'react';
import { IconProps } from '.';

const SvgBoxStock = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M20.5 2v17h-17V2h17ZM9.45 3.5H5v14h14v-14h-4.45v6.15h-5.1V3.5Zm1.5 0v4.65h2.1V3.5h-2.1Z'
        clipRule='evenodd'
      />
      <path fill={color} d='M2 22v-1.5h20V22H2Z' />
    </svg>
  );
};

export default SvgBoxStock;
